import React, { useEffect, useState } from "react";
import { FormSection, TextInput } from "../../../components";

import * as s from './formPesquisa.module.css';

export default function FormPesquisaPorGeanologia({ handleConsulta }) {
  const [consulta, setConsulta] = useState("");
  const [depsOpen, setDepsOpen] = useState(true);

  const handleInput = (event) => {
    const { name, value } = event.target;
    setConsulta({ ...consulta, [name]: value });
  };

  useEffect(() => {
    handleConsulta(consulta);
    // eslint-disable-next-line
  }, [consulta]);

  return (
    <div className="main-content">
      <FormSection title="Pesquisa por Genealogia"  borderBottomWidth={361}>
        <TextInput
          placeholder="Série do pai"
          name="seriePai"
          onChange={(value) => handleInput( value )}          
        />

        <TextInput
          placeholder="RGN do pai"
          name="rgnPai"
          onChange={(value) => handleInput( value )}          
        />

        <TextInput
          placeholder="RGD do pai"
          name="rgdPai"
          onChange={(value) => handleInput( value )}          
        />

        <TextInput
          placeholder="Série da mãe"
          name="serieMae"
          onChange={(value) => handleInput( value )}          
        />

        <TextInput
          placeholder="RGN da mãe"
          name="rgnMae"
          onChange={(value) => handleInput( value )}          
        />

        <TextInput
          placeholder="RGD da mãe"
          name="rgdMae"
          onChange={(value) => handleInput( value )}          
        />
      </FormSection>
    </div>
  );
}
